import { ReactElement } from 'react'

import FindByCodigoOcOuLoteSolicitadoIdImpl from 'shared/modules/ordemCarregamento/domain/usecases/FindByCodigoOcOuLoteSolicitadoIdImpl'
import OrdemCarregamentoRepository from 'shared/modules/ordemCarregamento/infra/repositories/OrdemCarregamentoRepository'
import SendSmsImpl from '../../domain/usecases/SendSmsImpl'
import LoteSolicitadoRepository from '../../infra/repositories/LoteSolicitadoRepository'

import DetalhesLoteSolicitado from '../../pages/DetalhesLoteSolicitado'

export const DetalhesLoteSolicitadoFactory = (): ReactElement => {
  const loteSolicitadoRepository = new LoteSolicitadoRepository()
  const ordemCarregamentoRepository = new OrdemCarregamentoRepository()
  const sendSmsImpl = new SendSmsImpl(loteSolicitadoRepository)
  const findByCodigoOcOuLoteSolicitadoIdImpl =
    new FindByCodigoOcOuLoteSolicitadoIdImpl(ordemCarregamentoRepository)

  return (
    <>
      <DetalhesLoteSolicitado
        findByCodigoOcOuLoteSolicitadoId={findByCodigoOcOuLoteSolicitadoIdImpl}
        sendSms={sendSmsImpl}
      />
    </>
  )
}
